import { RouteObject } from "react-router-dom";
import HomePage from "../pages/home/page";
import ServicesPage from "../pages/services/page";
import AboutPage from "../pages/about/page";
import LocationPage from "../pages/location/page";
import NotFound from "../pages/NotFound";

const routes: RouteObject[] = [
  { path: "/", element: <HomePage /> },
  { path: "/services", element: <ServicesPage /> },
  { path: "/about", element: <AboutPage /> },
  { path: "/location", element: <LocationPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;